import React, { useCallback } from 'react';
import { PiAddressBook } from 'react-icons/pi';
import { useParams } from 'react-router-dom';
import { Input } from 'rizzui';
import useFetch from '../../../../../hooks/useFetch';
import FormGroup from '../../../../../layout/shared/form-group';
import moment from 'moment';
import { HeadquarterService } from '../../../../../services/headquarters/headquarterService';
import { HeadquarterApiResponse } from '../../../../../type/entities/headquarter-type';

interface HeadquarterInfoProps { }

const HeadquarterInfo: React.FC<HeadquarterInfoProps> = () => {

    // HOOKS
    
    const { id = '' } = useParams<{ id: string }>();
    const service = new HeadquarterService();

    // DATA FETCHING

    // -----------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LOS DATOS DE LA SEDE POR ID
     * @EN GETS THE HEADQUARTER DATA BY ID
     */
    // -----------------------------------------------------------------------------------------------------
    const [data, loading] = useFetch(useCallback(async () => {
        if (!id || id === '') return null;
        const response = await service.getHeadquarterById(id);
        return response.getResponseData() as HeadquarterApiResponse;    
    }, [id]));
    // -----------------------------------------------------------------------------------------------------

    // RENDER

    return (
        <>
            <div className="@container">
                <div className="grid gap-7 divide-y-2 divide-dashed divide-gray-200">
                    <FormGroup
                        title="Información General"
                        description="Datos principales"
                        className='pt-4'
                        titleCols="@md:col-span-2"
                        childCols="@md:col-span-10 md:grid-cols-4"
                    >
                        <Input
                            disabled
                            label="Nombre"
                            className="md:col-span-2"
                            placeholder="Nombre de la sede"
                            value={data?.name ?? ""}
                        />
                        <Input
                            disabled
                            label="Dirección"
                            className="md:col-span-2"
                            value={data?.address ?? ""}
                        />
                        
                        <Input
                            disabled
                            label="Provincia"
                            className="md:col-span-2"
                            value={data?.province ?? ""}
                        />
                        
                        <Input
                            disabled
                            label="Ciudad"  
                            className="md:col-span-2"
                            value={data?.city ?? ""}
                        />

                        <Input
                            disabled
                            label="Barrio"
                            className="md:col-span-1"
                            value={data?.neighbourhood ?? ""}
                        />
                        <Input
                            disabled
                            label="Código Postal"
                            className="md:col-span-1"
                            value={data?.zipCode ?? ""}
                        />
                        
                        <Input
                            disabled
                            label="Nombre Contacto"
                            className="md:col-span-2"
                            value={data?.contactName ?? ""}
                        />

                        <Input
                            disabled
                            label="Email"
                            className="md:col-span-2"
                            value={data?.email || data?.provider?.email || ""}
                        />

                        <Input
                            disabled
                            label="Teléfono Móvil"
                            className="md:col-span-2"
                            value={data?.mobilePhone ?? ""}
                        />
                        <Input
                            disabled
                            label="Teléfono Fijo"
                            className="md:col-span-2"
                            value={data?.phone ?? ""}
                        />

                        {/*
                        <Input
                            disabled
                            label="Numero de Bidones"
                            className="md:col-span-2"
                            value={data?.drumsNumber ?? ""}
                        />
                        */}

                        <Input
                            disabled
                            label="Días de recogida"
                            className="md:col-span-2"
                            value={data?.pickBetweenDays ?? ""}
                        />

                        <Input
                            disabled
                            label="Día de descanso "
                            className="md:col-span-2"
                            value={data?.dayOff ?? ""}
                        />

                        <Input
                            disabled
                            label="Inicio de Servicio"
                            className="md:col-span-1"
                            value={data?.startService ? moment(data.startService.date || data.startService).format('DD/MM/YYYY') : ""}
                        />
                        <Input
                            disabled
                            label="Fin de Servicio"
                            className="md:col-span-1"
                            value={data?.endService ? moment(data.endService.date || data.endService).format('DD/MM/YYYY') : ""}
                        />

                        <Input
                            disabled
                            label="Horario de Recogida"
                            className="md:col-span-2"
                            value={data?.pickupSchedule ?? ""}
                        />

                        <Input
                            disabled
                            label="Gratificación"
                            className="md:col-span-2"
                            value={data?.gratification ?? ""}
                        />


                        <Input
                            disabled
                            label="Temporada alta"
                            className="md:col-span-1"
                            value={data?.highSeason ? 'Si' : 'No'}
                        />
                        <Input
                            disabled
                            label="Coordenadas"
                            className="md:col-span-1"
                            value={data?.coordinates ?? ""}
                        />



                        {/* Nueva visualización de fechas de temporada alta */}
                        <div className="md:col-span-2">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Períodos de Temporada Alta
                            </label>
                            <div className="space-y-3">
                                {(() => {
                                    // Decodificar highSeasonDates si es un string JSON
                                    let highSeasonDates = data?.highSeasonDates;
                                    if (typeof highSeasonDates === 'string') {
                                        try {
                                            highSeasonDates = JSON.parse(highSeasonDates);
                                        } catch (error) {
                                            console.error('Error parsing highSeasonDates:', error);
                                            highSeasonDates = [];
                                        }
                                    }
                                    
                                    return highSeasonDates && Array.isArray(highSeasonDates) && highSeasonDates.length > 0 ? (
                                        highSeasonDates.map((period: any, index: number) => (
                                            <div key={index} className="bg-gray-50 p-3 rounded-lg border">
                                                <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-sm">
                                                    <div>
                                                        <span className="font-medium text-gray-600">Período {index + 1}:</span>
                                                    </div>
                                                    <div>
                                                        <span className="text-gray-800">
                                                            {moment(period.dateFrom).format('DD/MM/YYYY')} - {moment(period.dateTo).format('DD/MM/YYYY')}
                                                        </span>
                                                    </div>
                                                    {/* <div>
                                                        <span className="text-gray-600">
                                                            Coordenadas: <br/>{period.coordinates || 'No definidas'}
                                                        </span>
                                                    </div> */}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="bg-gray-50 p-3 rounded-lg border text-center text-gray-500">
                                            No hay períodos de temporada alta configurados
                                        </div>
                                    );
                                })()}
                            </div>
                        </div>



                        <Input
                            disabled
                            label="Fecha de creación"
                            className="md:col-span-2"
                            value={moment(data?.createdAt?.date).format('DD/MM/YYYY')}
                        />

                        <Input
                            disabled
                            label="Fecha de actualización"
                            className="md:col-span-2"
                            value={data?.updatedAt ? moment(data?.updatedAt?.date).format('DD/MM/YYYY') : ''}
                        />

                        <Input
                            disabled
                            label="Observaciones"
                            className="md:col-span-4"
                            value={data?.comments ?? ""}
                        />

                    </FormGroup>

                    <FormGroup
                        title="Organización"
                        description="Datos de la organización"
                        className='pt-4'
                        titleCols="@md:col-span-2"
                        childCols="@md:col-span-10 md:grid-cols-3"
                    >
                        <Input
                            disabled
                            label="Nombre"
                            placeholder="Nombre de la organización"
                            value={data?.company?.name ?? ""}
                        />
                        <Input
                            id="companyCif"
                            disabled
                            label="CIF"
                            value={data?.company?.cif ?? ""}
                        />
                        <Input
                            prefix={<PiAddressBook className="h-6 w-6 text-gray-500" />}
                            label="Dirección"
                            placeholder="info@rochel.es"
                            value={data?.company?.address ?? ""}
                            disabled
                        />
                    </FormGroup>
                </div>
            </div>
        </>
    );
};

export default HeadquarterInfo;
